/*
 * @Description:
 * @Author: lei.zheng
 * @Date: 2019-09-21 10:56:52
 * @LastEditTime: 2024-03-22 11:26:19
 * @LastEditors: qiaoxin
 */

import { request, exportFile } from '@koi-design/vix-tools';
// import { message } from '@koi-design/uxd-ui';
import {
  packApi,
  parseFileName,
  getFileNameFromContentDisposition
} from '@/libs/tools';

// auth tree
export function createRobot(data) {
  return packApi({
    url: '/api/api-robot/robot/robots/',
    method: 'post',
    data
  });
}

export function createRobotNew(data) {
  return packApi(
    {
      url: `/api/api-robot/robot/robots/`,
      method: 'post',
      data
    },
    'object'
  );
}

export function getRobotsApi(data) {
  return request({
    url: '/api/api-robot/robot/robots/',
    method: 'get',
    data
  });
}

export function getQueryRewriteModelsApi(data) {
  return request({
    url: '/api/api-robot/query_rewrite_models/',
    method: 'get',
    data
  });
}

export function getRobotBoundSkillsApi(data) {
  return request({
    url: '/api/api-robot/robot/robots/bound_skills/',
    method: 'get',
    data
  });
}

export function getRobotBoundSkillsBySecretIdApi(data) {
  return request({
    url: '/api/api-robot/robot/robots/bound_skills_by_secret_id/',
    method: 'get',
    data
  });
}

export const downRuleWordTemplate = data => {
  return request({
    url: `/api/api-robot/robot/robots/download_template/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
};

export function downRuleWordTemplateApi(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/api-robot/robot/robots/download_template/',
      method: 'get',
      data,
      responseType: 'blob',
      catchAll: true
    })
      .then(res => {
        const filename =
          res.headers['content-disposition'] &&
          getFileNameFromContentDisposition(res.headers['content-disposition']);
        const { fileName, extension } = parseFileName(filename);
        resolve(exportFile(res.data, fileName, extension));
      })
      .catch(err => {
        reject(err);
      });
  });
}

export const uploadFileApi = data => {
  return request({
    url: `/api/api-robot/robot/robots/upload_robot_template/`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000 * 10
  });
};

export const getAvatarApi = data => {
  return request({
    url: '/api/api-avatar/avatars/',
    method: 'get',
    data
  });
};

export const getBotInfoApi = data => {
  const url = data.isMultiAgent
    ? `/api/v1/multi-agent/info/${data.id}`
    : `/api/api-robot/robot/robots/${data.id}/`;
  console.log('data', data);
  return request({
    url,
    method: 'get',
    data
  });
};

export const getDraftReleaseInfoApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/draft_release_info/',
    method: 'post',
    data
  });
};

const transferDraftValidationResponse = response => {
  if (response.code === '000000') return response.data;
  if (response.code === '400000') return Promise.reject(response);
  return Promise.reject(response.message);
};

export const updateBotDraftInfoApi = data => {
  return request({
    url: `/api/api-robot/robot/robots/update_draft/`,
    method: 'post',
    data,
    removeEmptyFields: false,
    responseTransfer: transferDraftValidationResponse
  });
};

export const updateBotInfoApi = (data, id) => {
  return request({
    url: `/api/api-robot/robot/robots/${id}/`,
    data,
    method: 'put',
    removeEmptyFields: false
  });
};
export const updateBotInfoApiNew = data => {
  return packApi({
    url: `/api/api-robot/robot/robots/update_robot_avatar/`,
    data,
    method: 'put',
    removeEmptyFields: false
  });
};

export const getBotKnowledgeApi = data => {
  return request({
    url: `/api/api-robot/robot/robots/${data.id}/get_robot_knowledge_bases/`,
    method: 'get'
  });
};

// export const getHistoryMessageApi = data => {
//   return request({
//     url: `/api/api-conversation/conversation/get_history/`,
//     method: 'get',
//     data
//   });
// };
//

export const getAllMessageApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_classified_conversation/`,
    method: 'get',
    data
  });
};

export const getMessageBySessionIdApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_conversation_segment_history/`,
    method: 'get',
    data
  });
};

export const getMessageBySessionIdDetailApi = data => {
  return request({
    url: `/api/api-conversation/segment/get_conversation_segment_detail/`,
    method: 'get',
    data
  });
};

export const getSessionListApi = data => {
  return request({
    url: `/api/api-conversation/segment/get_conversation_segment_list/`,
    method: 'get',
    data
  });
};

export const createSessionApi = data => {
  return request({
    url: `/api/api-conversation/segment/get_conversation_segment_code/`,
    method: 'get',
    data
  });
};

export const deleteConversionApi = data => {
  return packApi({
    url: `/api/api-conversation/segment/delete_conversation_segment/`,
    method: 'get',
    data
  });
};
export const deleteBatchConversionApi = data => {
  return packApi({
    url: `/api/api-conversation/segment/delete_batch_conversation_segment/`,
    method: 'post',
    data
  });
};

export const getClassifyMessageApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_classified_conversation_v2/`,
    method: 'get',
    data
  });
};

export const getMessageSortCountApi = data => {
  return request({
    url: `/api/api-conversation/conversation/count_conversation_history/`,
    method: 'get',
    data
  });
};

export const getChatModelApi = data => {
  return request({
    url: `/api/api-robot/chat_model_options/`,
    method: 'get',
    data
  });
};

export const getImageModelOptionsApi = data => {
  return request({
    url: '/api/api-robot/image_model_options/',
    method: 'get',
    data,
    catchAll: true
  });
};

export const getImageModelListFallbackApi = data => {
  return request({
    url: '/api/admin-api-robot/image_model/model_list/',
    method: 'get',
    data: {
      status: 1,
      page: 1,
      pagesize: 100,
      ...data
    },
    catchAll: true
  });
};

export function deleteMsgApi(id) {
  return request({
    url: `/api/api-conversation/conversation/${id}/`,
    catchAll: true,
    method: 'delete'
  });
}

export function editMsgApi(data, id) {
  return request({
    url: `/api/api-conversation/conversation/${id}/`,
    method: 'put',
    catchAll: true,
    data
  });
}

export function deleteBotApi(data) {
  console.log('data', data);
  const url =
    data.agent_type === 3
      ? `/api/v1/multi-agent/draft/${data.robot_id}`
      : '/api/api-robot/robot/robots/delete_robot/';
  return packApi({
    url,
    method: data.agent_type === 3 ? 'DELETE' : 'POST',
    data
  });
}

export function publishBotApi(data) {
  return packApi({
    url: `/api/api-robot/robot/robots/release_Dtalk/`,
    method: 'POST',
    data
  });
}

export function getDetailDDBotApi(data) {
  return request({
    url: `/api/api-robot/robot/robots/get_dtalk_configuration_info/`,
    method: 'get',
    data
  });
}

export function getMultiAgentDingConfigApi(data) {
  return request({
    url: '/api/api-robot/robot/dding/get_config/',
    method: 'get',
    data
  });
}

export function setMultiAgentDingConfigApi(data) {
  return packApi({
    url: '/api/api-robot/robot/dding/set_config/',
    method: 'post',
    data
  });
}

export function unbindMultiAgentDingConfigApi(data) {
  return packApi({
    url: '/api/api-robot/robot/dding/unbind/',
    method: 'post',
    data
  });
}

export function getIdBySecretIdApi(data) {
  return request({
    url: `/api/api-robot/robot/robots/get_robot_by_secret_id/`,
    method: 'get',
    data,
    catchAll: true
  });
}

export function getBotBySecretIdApi(data) {
  return request({
    url: `/api/api-robot/robot/robots/get_robot_by_secret_id_v1/`,
    method: 'get',
    data,
    catchAll: true
  });
}

export function getGenerateSecretIdApi(data) {
  const url = data.isMultiAgent
    ? `/api/v1/multi-agent/third-party/secret-key`
    : `/api/api-robot/robot/robots/generate_secret_id/`;
  return request({
    url,
    method: 'get',
    data
  });
}

export function setGuideReadingApi(data, id) {
  return request({
    url: `/api/api-robot/guide-reading/${id}/`,
    method: 'post',
    data
  });
}

export function getGuideReadingApi(id) {
  return request({
    url: `/api/api-robot/guide-reading/${id}/`,
    method: 'get'
  });
}

export function getBotKeyApi(data) {
  const urlMap = {
    3: '/api/v1/multi-agent/third-party/robot-token',
    5: '/api/v1/workflow-agent/agents/secret'
  };
  return request({
    url: urlMap[data.agent_type] || '/api/api-robot/robot-key/',
    method: 'post',
    data
  });
}

export function setBotExpireDate(data) {
  return request({
    url: `/api/api-robot/robot-key/`,
    method: 'post',
    data
  });
}

export function checkMailPhoneApi(data) {
  return request({
    url: `/api/api-user/check_user_register/`,
    method: 'get',
    data,
    catchAll: true,
    removeEmptyFields: false
  });
}

export function getDefaultNameApi(data) {
  return request({
    url: `/api/api-knowledge/knowledge/knowledge_folder/get_folder_default/`,
    method: 'get',
    data
  });
}

export function getFolderFlatTreeApi(data) {
  return request({
    url: `/api/api-knowledge/knowledge/knowledge_folder/get_folder_file_tree/`,
    method: 'get',
    data
  });
}

export const insertQaApi = data => {
  return request({
    url: `/api/api-conversation/conversation/update_role_answer/`,
    method: 'post',
    data,
    catchAll: true
  });
};

export function modifySessionApi(data) {
  return packApi({
    url: `/api/api-conversation/segment/modify_conversation_segment/`,
    method: 'post',
    data
  });
}

export function getConversationNewApi(data) {
  return request({
    url: `/api/api-conversation/segment/get_conversation_segment/`,
    method: 'get',
    data
  });
}

export function getConversationSegmentUserNicknameListApi(data) {
  return request({
    url: `/api/api-conversation/segment/user_code_list/`,
    method: 'get',
    data
  });
}

// downLoadConversationApi

export const downLoadConversationApi = data => {
  return request({
    url: `/api/api-conversation/segment/get_conversation_segment/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
};

export function getShareConversationListApi(data) {
  return request({
    url: `/api/api-conversation/segment_share/get_conversation_segment_list_share/`,
    method: 'post',
    data
  });
}

export function createShareSessionApi(data) {
  return request({
    url: `/api/api-conversation/segment_share/get_conversation_segment_code_share/`,
    method: 'post',
    data
  });
}

export function modifyShareSessionApi(data) {
  return packApi({
    url: `/api/api-conversation/segment_share/modify_conversation_segment_share/`,
    method: 'post',
    data
  });
}

export function deleteShareSessionApi(data) {
  return request({
    url: `/api/api-conversation/segment_share/delete_conversation_segment_share/`,
    method: 'post',
    data
  });
}
export function deleteBatchShareSessionApi(data) {
  return request({
    url: `/api/api-conversation/segment_share/delete_batch_conversation_segment_share/`,
    method: 'post',
    data
  });
}

export const getEmbeddingModelListApi = data => {
  return request({
    url: `/api/api-robot/embedding_model_options/`,
    method: 'get',
    data
  });
};

/** Resolve deprecated model name to replacement (admin). LLM: omit model_type in caller params. */
export const resolveModelNameApi = data => {
  return request({
    url: `/api/admin-api-robot/model/resolve_model_name/`,
    method: 'get',
    data
  });
};

export const multimodalResolveModelNameApi = data => {
  return request({
    url: `/api/admin-api-robot/model/multimodal_resolve_model_name/`,
    method: 'get',
    data
  });
};

/** Resolve deprecated slang scene id to replacement. */
export const resolveSlangSpecificSceneApi = data => {
  return request({
    url: `/api/api-robot/robot/slang_specific_scenes/resolve_slang_specific_scene/`,
    method: 'get',
    data
  });
};

export const getRobotDefaultConfigApi = () => {
  return request({
    url: '/api/api-robot/robot/robots/default_robot/',
    method: 'get'
  });
};

export const getDefaultModelApi = () => {
  return request({
    url: '/api/api-robot/robot/robots/default_model/',
    method: 'get'
  });
};

export const getRobotResponseTimeApi = data => {
  return request({
    url: '/api/api-conversation/conversation/get_convertion_time/',
    method: 'get',
    data
  });
};

export const getTimeZoneListApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_time_zone_list/',
    method: 'get',
    data
  });
};

export const getMarketListApi = () => {
  return request({
    url: '/api/api-robot/robot/robots/search_market_code_list/',
    method: 'get'
  });
};

export const getSearchLangListApi = () => {
  return request({
    url: '/api/api-robot/robot/robots/search_language_list/',
    method: 'get'
  });
};

export const getLongTermMemoryConfigApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_long_term_memory_config/',
    method: 'get',
    data
  });
};

export const saveLongTermMemoryConfigApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/save_long_term_memory_config/',
    method: 'post',
    data
  });
};

export const getHomelandRobotsApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_homeland_robots/',
    method: 'post',
    data
  });
};

export const getRobotKnowledgeThresholdApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_robot_knowledge_threshold/',
    method: 'get',
    data
  });
};

export const getRobotReleaseStatusApi = data => {
  return request({
    url: '/api/api-robot/robot/release/status/',
    method: 'get',
    data
  });
};

export const getNextReleaseVersionApi = data => {
  const url =
    String(data?.agent_type) === '3'
      ? '/api/v1/multi-agent/next-version'
      : '/api/api-robot/robot/release/next_version/';
  return request({
    url,
    method: 'get',
    data
  });
};

export const releaseRobotApi = (data, showTip = true) => {
  let url = '/api/api-robot/robot/release/release/';
  if (data.publish_type === 3) {
    url = '/api/v1/multi-agent/release';
  } else if (data.publish_type === 5) {
    url = '/api/v1/workflow-agent/agents/release';
  }

  return packApi(
    {
      url,
      method: 'post',
      data
    },
    'boolean',
    showTip
  );
};

export const getReleaseRecordApi = data => {
  const url =
    data.use_type === 'multiAgent'
      ? `/api/v1/multi-agent/${data.robot_id}/release`
      : '/api/api-robot/robot/release/record/';
  return request({
    url,
    method: 'get',
    data
  });
};
export const getSlangConfigApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_slang_config/',
    method: 'get',
    data
  });
};

// Save slang configuration
export const saveSlangConfigApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/save_slang_config/',
    method: 'post',
    data
  });
};

export const getSceneListApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_slang_scenes/',
    method: 'get',
    data
  });
};
// sort bot
export const sortBotApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/robot_sort/',
    method: 'put',
    data
  });
};

export const getRerankingModelListApi = data => {
  return request({
    url: '/api/api-robot/reranking_model_options/',
    method: 'get',
    data
  });
};

/** Get reranking model options by language, used for reranking model dropdown in workflow nodes */
export const getRerankingModelsOptionsListApi = (language = 'zh') => {
  return request({
    url: '/api/api-robot/reranking_model_options/',
    method: 'get',
    data: { language }
  });
};
export const getPromptTemplateApi = () => {
  return request({
    url: '/api/api-robot/robot/prompt/',
    method: 'get'
  });
};

export const getModelListApi = data => {
  return request({
    url: '/api/api-robot/chat_model_options_v2/',
    method: 'get',
    data
  });
};

export const getReleaseDescApi = data => {
  return request({
    url: '/api/api-robot/robot/release/desc/',
    method: 'get',
    data
  });
};

export const getReleaseErrorApi = data => {
  return request({
    url: '/api/api-robot/robot/release/release_error/',
    method: 'get',
    data
  });
};

export const getResourceListApi = data => {
  return request({
    url: '/api/api-robot/robot/resource/resource_list/',
    method: 'get',
    data
  });
};

export const getResourcePermissionApi = data => {
  return request({
    url: '/api/api-robot/robot/resource/resource_permission/',
    method: 'get',
    data
  });
};

// Check agent variable key validation
export const checkAgentVariableApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/check_agent_variable/',
    method: 'post',
    data
  });
};

export const getLongTermVariableOptionsApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_long_term_variable_options/',
    method: 'get',
    data
  });
};
export const getRiskControlOptionsApi = () => {
  return request({
    url: '/api/api-robot/risk_control_options/',
    method: 'get'
  });
};
export function getIntentSftModelOptionsApi(data) {
  return request({
    url: '/api/api-robot/intent_sft_model_options/',
    method: 'get',
    data
  });
}

export function saveIntentionConfigApi(data) {
  return request({
    url: '/api/api-robot/robot/robots/save_intention_config/',
    method: 'post',
    data
  });
}

// Get trigger auto reply configuration
export const getTriggerAutoReplyApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/get_trigger_auto_reply/',
    method: 'post',
    data
  });
};

// Get trigger auto reply configuration
export const getTriggerAutoReplyOpenApi = data => {
  return request({
    url: '/openapi/v1/robot/get_trigger_auto_reply/',
    method: 'post',
    data
  });
};

// Get Lark approval sample data for trigger
export const getTriggerLarkSampleApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/trigger_lark_sample/',
    method: 'get',
    data
  });
};

// Search DingTalk users for trigger push channel
export const searchDingTalkUserApi = data => {
  return packApi(
    {
      url: '/api/api-robot/robot/robots/dingtalk_user_search/',
      method: 'get',
      params: data
    },
    'object',
    false
  );
};

export const getTraceListApi = data => {
  return request({
    url: '/api/v1/traces/query/',
    method: 'get',
    params: data,
    removeEmptyFields: false
  });
};

export const getTracesHierarchyListApi = data => {
  return request({
    url: '/api/v1/traces/hierarchy-list/',
    method: 'get',
    params: data
  });
};

export const getTracesSpanDetailApi = data => {
  return request({
    url: '/api/v1/traces/span/detail/',
    method: 'get',
    params: data
  });
};

export const restoreFromReleaseApi = data => {
  const url =
    data.use_type === 'multiAgent'
      ? `/api/v1/multi-agent/draft/release/copy`
      : '/api/api-robot/robot/release/restore_from_release/';
  return packApi({
    url,
    method: 'post',
    data
  });
};

// Get agent metrics (subscription_count, user_count, conversation_count)
export const getAgentMetricsApi = data => {
  return request({
    url: '/api/statistics/agent/metrics/',
    method: 'post',
    data
  });
};

export const validateDraftApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/validate_draft/',
    method: 'post',
    data,
    responseTransfer: transferDraftValidationResponse
  });
};

export const generateSystemPromptApi = data => {
  return request({
    url: '/api/api-robot/robot/robots/generate_system_prompt/',
    method: 'post',
    data
  });
};
